import "./css/masterslider.css";
import "./css/ms-tabs-style.css";
import "./css/jquery-ui-1.css";
import "./css/font-awesome.css";
import "./css/bootstrap.css";
import "./css/bootstrap-responsive.css";
import "./css/stylesheet.css";
import "./css/cloud-zoom.css";
import "./css/jquery.css";
import "./css/pavmegamenu.css";
import "./css/style.css";
import "./css/pavblog.css";
import "./css/catslider.css";
import "./css/easydropdown.css";
import "./css/custom-responsive.css";
import "./css/slideshow.css";
import "./css/carousel.css";
import "./css/colorbox.css";
//import 'bootstrap/dist/css/bootstrap.min.css';
import "./js/notyfy/jquery.notyfy.css";
import "./js/notyfy/themes/default.css";
import jquery from "jquery"; //./js/jquery-1.11.1.min.js
//import bootstrap from 'bootstrap/dist/js/bootstrap';
window.jQuery = jquery;
window.$ = jquery;

//import Hammer from 'hammerjs/hammer';
//require('webpack-jquery-ui');
//require('webpack-jquery-ui/css');
jQuery.curCSS = function(element, prop, val) {
  return jQuery(element).css(prop, val);
};
require("./js/bootstrap.js");
require("./js/jquery-ui-1.js");
require("./js/jquery.catslider.js");
require("./js/common.js");
require("./js/cloud-zoom.js");
require("./js/livesearch.js");
require("./js/jquery_002.js");
require("./js/jquery_006.js");
require("./js/jquery_008.js");
require("./js/masterslider.js");
require("./js/custom-select-menu.js");
require("./js/jquery_005.js");
require("./js/totop.js");
require("./js/jquery_010.js");
require("./js/jquery_004.js");
require("./js/jquery_003.js");
require("./js/jquery_009.js");
require("./js/jquery_007.js");
require("./js/jquery_011.js");
require("./js/custom.js");
require("./js/jquery.reject.min.js");
require("./js/notyfy/jquery.notyfy");
//require('./js/widgets.js');

//require('./js/noty/js/noty/jquery.noty.min.js');

import LazyLoad from "vanilla-lazyload";

var lazyLoadInstances = [];
// The "lazyLazy" instance of lazyload is used (kinda improperly)
// to check when the .horzContainer divs enter the viewport
var lazyLazy = new LazyLoad({
  elements_selector: ".horzContainer",
  // When the .horzContainer div enters the viewport...
  callback_enter: function(el) {
    // ...instantiate a new LazyLoad on it
    var oneLL = new LazyLoad({
      container: el,
    });
    // Optionally push it in the lazyLoadInstances
    // array to keep track of the instances
    lazyLoadInstances.push(oneLL);
  },
});

var loadDeferredStyles = function() {
  let addStylesNode = document.getElementById("deferred-styles");
  let replacement = document.createElement("div");
  replacement.innerHTML = addStylesNode.textContent;
  document.body.appendChild(replacement);
  addStylesNode.parentElement.removeChild(addStylesNode);
};
var raf =
  window.requestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.msRequestAnimationFrame;
if (raf)
  raf(function() {
    window.setTimeout(loadDeferredStyles, 0);
  });
else window.addEventListener("load", loadDeferredStyles);

var evideo = document.getElementById("video");
if (typeof evideo != "undefined" && evideo != null) {
  window.onscroll = function() {
    let rect = document.getElementById("video").getBoundingClientRect();
    let url_video =
      "//www.youtube.com/embed/37EDSFbtfjo?enablejsapi=1&origin=goapp.mx";
    if (rect.top < window.innerHeight) {
      evideo.src = url_video;
      loadVideo();
      window.onscroll = null;
    }
  };
}
//Google Analytics
(function(i, s, o, g, r, a, m) {
  i["GoogleAnalyticsObject"] = r;
  (i[r] =
    i[r] ||
    function() {
      (i[r].q = i[r].q || []).push(arguments);
    }),
    (i[r].l = 1 * new Date());
  (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
  a.async = 1;
  a.src = g;
  m.parentNode.insertBefore(a, m);
})(window, document, "script", "//www.google-analytics.com/analytics.js", "ga");

ga("create", "UA-61693117-1", "auto");
ga("send", "pageview");

(function(d, s, id) {
  let js,
    fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) return;
  js = d.createElement(s);
  js.id = id;
  js.async = true;
  js.src = "//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.0";
  fjs.parentNode.insertBefore(js, fjs);
})(document, "script", "facebook-jssdk");
function getURLVar(key) {
  var value = [];

  var query = String(document.location).split("?");

  if (query[1]) {
    let part = query[1].split("&");

    for (i = 0; i < part.length; i++) {
      var data = part[i].split("=");

      if (data[0] && data[1]) {
        value[data[0]] = data[1];
      }
    }

    if (value[key]) {
      return value[key];
    } else {
      return "";
    }
  }
}

function addToCart(product_id, quantity) {
  quantity = typeof quantity != "undefined" ? quantity : 1;
  let id_acabado = 0;
  let ischecked_method = false;        
  let radios = document.querySelectorAll('input[type="radio"]');
  for (var i = 0; i < radios.length; i++) {
    if (radios[i].type === 'radio' && radios[i].checked) {
      ischecked_method = true;
      break;       
    }
}
  if (true===ischecked_method) {
    id_acabado = document.querySelector('input[name="id_acabado"]:checked').value;
  }
  $.ajax({
    url: "panel/g000_1_ProcesaCarrito.php",
    type: "post",
    data:
      "idProducto=" +
      product_id +
      "&number=" +
      quantity +
      "&accion=add" +
      "&id_acabado=" +
      id_acabado,
    dataType: "script",
    success: function(data) {
      $("html, body").animate({ scrollTop: 0 }, "slow");
    },
    error: function(data) {
      alert("Ocurrio un error, por favor verifique e intente nuevamente.");
    },
  });
}
function addToCartPlus(product_id, quantity) {
  quantity = typeof quantity != "undefined" ? quantity : 1;
  $.ajax({
    url: "panel/g000_1_ProcesaCarrito.php",
    type: "post",
    data: "idProducto=" + product_id + "&number=" + quantity + "&accion=add",
    dataType: "script",
    success: function(data) {
      $("html, body").animate({ scrollTop: 0 }, "slow");
      window.location = "carrito_de_compras.php";
    },
    error: function(data) {
      alert("Ocurrio un error, por favor verifique e intente nuevamente.");
    },
  });
}
function addToWishList(product_id) {
  $.ajax({
    url: "index.php?route=account/wishlist/add",
    type: "post",
    data: "product_id=" + product_id,
    dataType: "json",
    success: function(json) {
      $(".success, .warning, .attention, .information").remove();
      $(window).colorbox.close();
      if (json["success"]) {
        $("#notification").html(
          '<div class="success" style="display: none;">' +
            json["success"] +
            '<img src="catalog/view/theme/default/image/close.png" alt="" class="close" /></div>'
        );

        $(".success").fadeIn("slow");

        $("#wishlist-total").html(json["total"]);

        $("html, body").animate({ scrollTop: 0 }, "slow");
      }
    },
  });
}

function addToCompare(product_id) {
  $.ajax({
    url: "index.php?route=product/compare/add",
    type: "post",
    data: "product_id=" + product_id,
    dataType: "json",
    success: function(json) {
      $(".success, .warning, .attention, .information").remove();
      $(window).colorbox.close();
      if (json["success"]) {
        $("#notification").html(
          '<div class="success" style="display: none;">' +
            json["success"] +
            '<img src="catalog/view/theme/default/image/close.png" alt="" class="close" /></div>'
        );

        $(".success").fadeIn("slow");

        $("#compare-total").html(json["total"]);

        $("html, body").animate({ scrollTop: 0 }, "slow");
      }
    },
  });
}
function addHit(a) {
  $.ajax({
    type: "POST",
    url: "panel/model/addHit.php",
    data: "idAnuncio=" + a,
    dataType: "script",
    success: function(b) {
      console.log(b);
    },
  });
}

window.getURLVar = getURLVar;
window.addToCart = addToCart;
window.addToCartPlus = addToCartPlus;
window.addToWishList = addToWishList;
window.addToCompare = addToCompare;
